<template>
    <!-- Componente para mostrar la sección de noticias del sitio -->
    <section class="news max-w-screen-xl mx-auto mb-16">
        <h1 class="font-bolder text-2xl mt-12 mb-8 px-8 sm:px-12">Noticias</h1>
        <img
            :src="imageType === 'mobile' ? `${url}/images/news/Mayo_1008x540.jpg` : `${url}/images/news/Mayo_1801x540.jpg`"
            alt="#HyundaiTeAcompaña"
        >
        <div class="px-8 sm:px-12">
            <h2 class="font-medium text-lg md:text-xl mt-6">Hyundai te acompaña</h2>
            <p class="mt-3">Conoce las acciones que tomamos para ti.</p>
            <p class="mt-3">En Hyundai comprendemos que en este momento necesitamos tomar medidas especiales para
                cuidarnos entre todos. Por eso continuamos con las acciones de Hyundai Te Acompaña. <br>No salgas de
                casa durante la contingencia. Estas son las opciones que tenemos para ti.</p>
            <p class="mt-3">
                1.- Cita de servicio:<br>
                Haz tu cita de servicio, nosotros vamos por el auto y lo regresamos a tu domicilio.<br>
                Consulta disponibilidad del servicio en tu Distribuidor Autorizado Hyundai más cercano.<br>
                <a
                    class="hyundai-button w-48 mt-2"
                    target="_blank"
                    href="https://www.hyundai.com.mx/servicio/"
                >Cita de servicio</a>
            </p>
            <p class="mt-3">
                2.- Cotiza tu Hyundai en línea:<br>
                Ponemos a tu disposición una cotización en línea , para que tomes la mejor decisión.<br>
                <a
                    class="hyundai-button w-48 mt-2"
                    target="_blank"
                    href="https://www.hyundai.com.mx/solicitar-cotizacion/"
                >Hyundai en línea</a>
            </p>
            <p class="mt-3">
                3.- Hyundai Live<br>
                Visita nuestra sala de exhibición desde la comodidad de tu sofá.<br>
                Conoce nuestros autos y resuelve todas tus dudas desde cualquier dispositivo móvil o desde tu
                computadora con Hyundai Live.<br>
                Visita Hyundai.com.mx de lunes a viernes de 10 a 13 h y de 14 a 18 h.<br>
                <a
                    class="hyundai-button w-48 mt-2"
                    target="_blank"
                    href="https://www.hyundai.com.mx/hyundai-live-otm/"
                >Hyundai Live</a>
            </p>
            <p class="mt-3">4.- Medidas de higiene Hyundai:<br>
                Para garantizar tu seguridad, acompañamos nuestras acciones a domicilio con las siguientes medidas:<br>
                <span class="ml-4">• Chofer debidamente acreditado.</span><br>
                <span class="ml-4">• Llevará cubreboca en todo momento.</span><br>
                <span class="ml-4">• Aplicará gel antibacterial en sus manos y en las del cliente.</span><br>
                <span class="ml-4">• Utilizará guantes para entregar y recibir el auto.</span><br>
                <span class="ml-4">• Desinfectará el volante, palanca de velocidades y tablero.</span><br>
                <span class="ml-4">• Colocará protecciones en volante palanca de velocidades y asiento.</span>
            </p>
            <p class="mt-3">5.- Recomendaciones Hyundai:<br>
                Limpia tu auto y reduce el riesgo de contagio.
            </p>
            <p class="mt-3">En esta situación estamos juntos, estamos contigo.<br>
                Encuentra a tu distribuidor más cercano en hyundai.com.mx o al 800 HYUNDAI (4986324) y agenda tu cita.
            </p>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            url: $('.url').text(),
            webpage: $('.webpage').text(),
            imageType: 'mobile'
        }
    },
    methods: {
        // Función para determinar el tamaño de la imagen del banner
        onResize() {
            if (window.innerWidth < 1024) {
                this.imageType = 'mobile'
            }
            else if (window.innerWidth >= 1024) {
                this.imageType = 'desktop'
            }
        }
    },
    created() {
        // En caso de que el tamaño de la pantalla cambie
        // llama a la función para determinar el tamaño del banner
        window.addEventListener('resize', this.onResize)
    },
    mounted() {
        this.onResize()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    }
}
</script>

<style>

</style>